export const ACHIEVEMENT_SOUNDS = [
  "/sounds/Achievement01.mp3",
  "/sounds/Achievement02.mp3",
  "/sounds/Achievement03.mp3",
  "/sounds/Achievement04.mp3",
];

export const playAchievementSound = (): void => {
  const src = ACHIEVEMENT_SOUNDS[Math.floor(Math.random() * ACHIEVEMENT_SOUNDS.length)];
  const audio = new Audio(src);
  audio.volume = 0.55;
  void audio.play().catch(() => undefined);
};
